// extracted by mini-css-extract-plugin
export default {"image":"MenuDrawer_image__K+NPJ","logo":"MenuDrawer_logo__BCNtS","list":"MenuDrawer_list__eIPUu"};